import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    { num: '01', key: 'how.step1' },
    { num: '02', key: 'how.step2' },
    { num: '03', key: 'how.step3' },
    { num: '04', key: 'how.step4' },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1000px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            {t('how.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.key} className="relative text-center group">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 mb-4">
                <span className="font-heading text-xl font-bold">{step.num}</span>
              </div>
              <p className="text-sm font-medium text-foreground-700">{t(step.key)}</p>
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-px bg-background-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}